import React, { Fragment } from 'react';

const ButtonGroupFilter = ({
    filterTitle,
    filterName,
    filtersInfo,
    filters,
    updateFilters,
}) => {
    const renderList = () => {
        if (filtersInfo != undefined && filtersInfo.length > 0) {
            let printList = [];

            filtersInfo.map((item, index) => {
                let filterId = item.Id;
                let filterIdCustom = item.Name;
                let filterDescription = item.Description;
                printList.push(
                    <label
                        className="c-button-group__item"
                        htmlFor={filterIdCustom}
                        key={index}
                    >
                        <input
                            id={filterIdCustom}
                            className="c-button-group__input"
                            type="checkbox"
                            name={filterName}
                            checked={filters[filterId] ? true : ''}
                            onChange={e =>
                                updateFilters({
                                    ...filters,
                                    [filterId]: !filters[filterId],
                                })
                            }
                        ></input>
                        <span className="c-button-group__label">
                            {filterDescription}
                        </span>
                    </label>
                );
            });
            return <div className="c-button-group">{printList}</div>;
        }
    };

    return (
        <Fragment>
            <div className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                    <button
                        className="c-accordion__title-label  js-accordion__title-label"
                        aria-expanded="true"
                        type="button"
                    >
                        <span className="c-accordion__title-label-text ">
                            {filterTitle}
                        </span>
                    </button>
                </h3>
            </div>
            <div
                className="c-accordion__panel  js-accordion__panel c-vehicle-filters__item-content c-vehicle-filters__item-content--button-group"
                aria-hidden="true"
            >
                <div className="c-accordion__content c-accordion__content--max-width">
                    {renderList()}
                </div>
            </div>
        </Fragment>
    );
};

export default ButtonGroupFilter;
